import { createElement, FC, RefObject } from 'react';

export interface Props {
  src: string;
  loop?: boolean;
  muted?: boolean;
  autoPlay?: boolean;
  controls?: boolean;
  nodownload?: boolean;
  playsInline?: boolean;
  poster?: string;
  videoRef?: RefObject<HTMLVideoElement>;
  onSeek?: (time: number) => void;
  onTimeUpdate?: (time: number) => void;
  className?: string;
  preloadAttr?: 'metadata' | 'none';
  disablePictureInPicture?: boolean;
}

const VideoScreen: FC<Props> = ({
  src,
  loop,
  muted = true,
  autoPlay,
  controls,
  nodownload,
  playsInline,
  poster,
  videoRef,
  onSeek = () => undefined,
  onTimeUpdate = () => undefined,
  className,
  preloadAttr,
  disablePictureInPicture,
}) => (
  <video
    loop={loop}
    muted={muted}
    autoPlay={autoPlay}
    controls={controls}
    poster={poster}
    playsInline={playsInline}
    controlsList={nodownload ? 'nodownload' : undefined}
    ref={videoRef}
    onSeeking={(e: any) => {
      onSeek(e.currentTarget.currentTime);
    }}
    onTimeUpdate={(e: any) => {
      onTimeUpdate(e.currentTarget.currentTime);
    }}
    className={className}
    key={src}
    preload={preloadAttr}
    disablePictureInPicture={disablePictureInPicture}
    style={style}
  >
    <source src={src} />
  </video>
);

// @emotion/styled だと disablePictureInPicture 属性を受け付けなかったので、ここだけ React.CSSProperties を利用しています。
const style: React.CSSProperties = {
  backgroundColor: '#000',
  objectFit: 'contain',
};

export default VideoScreen;
